// extracted by mini-css-extract-plugin
export default {"footerBar":"QuickPricerFooter_footerBar__1gAZ3","footerText":"QuickPricerFooter_footerText__frEv6"};